import { Component, Input } from '@angular/core';
import './bl-icons.js';

@Component({
    selector: 'bl-icon',
    template: `
    <svg [ngClass]="class || 'icon'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <use [attr.xlink:href]="'#it-' + icon"></use>
    </svg>
    `,
    styleUrls: ['./bl-icon.component.scss']
})
export class BLIconComponent {
    @Input() icon: string;
    @Input() class: string;
}